"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachTriggerDate = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const attachTriggerDate = (params) => {
    const { config, triggerDate } = params;
    const { triggerDates, globalRecurringDateConfigs, athenaQueries: rawAthenaQueries, athenaRecurringQueries: rawAthenaRecurringQueries, postgresQueries: rawPostgresQueries, intermediateFields: rawIntermediateFields, } = config;
    const errors = [];
    // *** Athena Query ***
    const athenaQueries = rawAthenaQueries.map((query) => {
        const queryName = query.query.name;
        if (queryName === 'triggerDate') {
            errors.push(`Athena query can not be named triggerDate`);
        }
        if (query.variables.find((variable) => variable.name === 'triggerDate')) {
            errors.push(`Trigger date should not be defined in athena query variables for ${queryName}`);
        }
        return {
            ...query,
            variables: [
                { name: 'triggerDate', value: triggerDate, parseNumber: true },
                ...query.variables,
            ],
        };
    });
    // *** Athena Recurring Query ***
    const athenaRecurringQueries = rawAthenaRecurringQueries.map((query) => {
        if (query.variables.find((variable) => variable.name === 'triggerDate')) {
            errors.push(`Trigger date should not be defined in athena recurring query variables for ${query.name}`);
        }
        return {
            ...query,
            variables: [
                { name: 'triggerDate', value: triggerDate, parseNumber: true },
                ...query.variables,
            ],
        };
    });
    // *** Postgres Query ***
    const postgresQueries = rawPostgresQueries.map((query) => {
        if (query.name === 'triggerDate') {
            errors.push(`Postgres query can not be named triggerDate`);
        }
        if (query.variables.find((variable) => variable.name === 'triggerDate')) {
            errors.push(`Trigger date should not be defined in postgres query variables for ${query.name}`);
        }
        return {
            ...query,
            variables: [
                { name: 'triggerDate', value: triggerDate, parseNumber: true },
                ...query.variables,
            ],
        };
    });
    // *** Intermediate Fields ***
    if (rawIntermediateFields.find((intermediateFields) => intermediateFields.field === 'triggerDate')) {
        errors.push('Trigger date should not be defined in intermediate fields.');
    }
    // make trigger date available to intermediate fields
    const intermediateFields = [
        {
            field: 'triggerDate',
            config: {
                formula: `"${triggerDate}"`,
                type: 'formula',
                engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
            },
        },
        ...rawIntermediateFields,
    ];
    if (errors.length > 0) {
        return { success: false, errors };
    }
    return {
        success: true,
        config: {
            triggerDates,
            globalRecurringDateConfigs,
            athenaQueries,
            athenaRecurringQueries,
            postgresQueries,
            intermediateFields,
        },
    };
};
exports.attachTriggerDate = attachTriggerDate;
//# sourceMappingURL=attach.js.map